// ReusableTooltip.js
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ReusableTooltip = ({ text, children }) => {
  return (
    <OverlayTrigger
      placement="top"
      trigger={['hover', 'focus']}
      delay={{ show: 200, hide: 0 }}
      overlay={<Tooltip className="light-tooltip">{text}</Tooltip>}
    >
      <span style={{ display: "inline-block" }}>{children}</span>
    </OverlayTrigger>
  );
};

export default ReusableTooltip;
